/**
 * Степпер (кит, «CRM: доска, степпер, лента»): мятным — ровно один
 * этап, на котором объект сейчас; пройденные тихие с галочкой, будущие
 * приглушены. Этап, который ставит человек, кликабелен; который ставит
 * система — подписан и объясняет почему в подсказке.
 */
export interface Step {
  key: string;
  title: string;
  /** Верхняя строка: «менеджер», «ставит система · сейчас здесь» */
  caption: string;
  state: 'done' | 'on' | 'next';
  /** Подсказка при наведении */
  hint?: string;
  onClick?: () => void;
}

export function Stepper({ steps }: { steps: Step[] }) {
  return (
    <div className="stepper">
      {steps.map((s) => {
        const cls = ['st'];
        if (s.state !== 'next') cls.push(s.state);
        if (s.onClick) cls.push('clk');
        return (
          <div key={s.key} className={cls.join(' ')} title={s.hint} onClick={s.onClick}>
            <div className="n">{s.caption}</div>
            <div className="t">{s.title}</div>
          </div>
        );
      })}
    </div>
  );
}
